import React from "react";

const ProgressIndicator = ({
  steps,
  currentStep,
  className
}) => {
  return (
    <div className={`progress-indicator ${className || ''}`}>
      <div className="progress-container">
        <div className="progress-steps">
          {steps.map((step, index) => (
            <div key={step.id} className="progress-step">
              <div className="progress-step-content">
                <div className={`progress-step-circle ${
                  step.id < currentStep 
                    ? 'completed' 
                    : step.id === currentStep 
                      ? 'current' 
                      : 'pending'
                }`}>
                  {step.id < currentStep ? (
                    <span style={{ fontSize: '16px' }}>✓</span>
                  ) : (
                    <span>{step.id}</span>
                  )}
                </div>
                <span className="progress-step-title">
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className="progress-connector">
                  <div className="progress-line">
                    <div className={`progress-line-fill ${
                      step.id < currentStep ? 'w-full' : 'w-0'
                    }`} />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { ProgressIndicator };
